import { pushToDataLayer } from "@/lib/analytics/pushToDataLayer";
import type { ToolCallEvent } from "./handlers/types";

export type AgentResponseType =
  | "default"
  | "error"
  | "navigate"
  | "application"
  | "appointment"
  | "form"
  | "scroll"
  | "show_action_buttons";

const TOOL_CALL_RESPONSE_TYPES: Record<
  ToolCallEvent["name"],
  AgentResponseType
> = {
  navigate: "navigate",
  navigate_and_scroll: "navigate",
  scroll: "scroll",
  show_dynamic_form: "form",
  show_lead_contact_form: "form",
  show_document_upload_form: "form",
  show_application_form: "application",
  suggest_appointment_dates: "appointment",
  show_action_buttons: "show_action_buttons",
};

export const getToolCallResponseType = (
  name: ToolCallEvent["name"]
): AgentResponseType => TOOL_CALL_RESPONSE_TYPES[name];

export const trackAgentResponse = (type: AgentResponseType): void => {
  pushToDataLayer({ event: "agent_response", type });
};
